/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserWorkflowStepStatus = {
  type: 'Enum',
} as const;
